import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BdsBusinessGroupComponent } from './bds-business-group.component';

@NgModule({
    declarations: [BdsBusinessGroupComponent],
    imports: [CommonModule],
})
export class BdsBusinessGroupModule {}
